import {MantineThemeColors} from '@mantine/core';

import {
  BenchlingNodeStatus,
  STATUS_COLORS,
} from 'ui-library/reactflow/nodes/BenchlingNode/BenchlingNodeConstants';

export interface BorderColors {
  borderColor: string;
  hoverBorderColor: string;
  hoverActiveBorderColor: string;
}

export function getBorderColors(
  theme: {colors: MantineThemeColors},
  opts: {isSelectable: boolean; isSelected: boolean; isPreview: boolean; status?: BenchlingNodeStatus}
): BorderColors {
  if (opts.isSelectable && opts.isSelected) {
    const borderColor = theme.colors.blue[7];
    return {borderColor, hoverBorderColor: borderColor, hoverActiveBorderColor: borderColor};
  }
  if (opts.isPreview && opts.status != null) {
    const {color, colorIndex} = STATUS_COLORS[opts.status];
    return {
      borderColor: theme.colors[color][colorIndex],
      hoverBorderColor: theme.colors.blue[4],
      hoverActiveBorderColor: theme.colors.blue[4],
    };
  }
  return {
    borderColor: theme.colors.gray[3],
    hoverBorderColor: theme.colors.blue[4],
    hoverActiveBorderColor: theme.colors.blue[4],
  };
}
